import { toast } from 'react-toastify'

import { wretchClient } from '~in-app/lib/wretch/wretch'

import { ProductFeature } from './types'

export const fetchProductFeatureList = async (params?: { abortCtrl?: AbortController | AbortSignal, query?: { productIds?: string } }) => {
  return wretchClient
    .url('/admin/1.0/products/features')
    .signal(params?.abortCtrl)
    .query(params?.query || {})
    .get()
    .json<{ list: ProductFeature[] }>()
    .catch((err) => {
      const parsedData = JSON.parse(err.message)
      toast.error(`Error: ${parsedData.message}`, { hideProgressBar: false, autoClose: 1500 })
      return null
    })
}
